export const SELECT_3_CHOICES = "You must select 3 choices or fewer.";
export const SELECT_5_CHOICES = "You must select 5 choices or fewer."
